const langDocumentFiles = {
	title: {
		tag: 'document.files.title',
		fr: 'Mes documents',
		en: 'My documents',
	},
	subtitle_quick_access: {
		tag: 'document.files.subtitle_quick_access',
		fr: 'Documents récents',
		en: 'Last reports',
	},
	document_distribution: {
		tag: 'document.files.document_distribution',
		fr: 'Répartition des documents',
		en: 'Document distribution',
	},
	company_documents: {
		tag: 'document.files.company_documents',
		fr: 'Documents de synthèse',
		en: 'Company documents',
	},
	subtitle_search: {
		tag: 'document.files.subtitle_search',
		fr: 'Recherche',
		en: 'Search',
	},
	subtitle_last_10_documents: {
		tag: 'document.files.subtitle_last_10_documents',
		fr: '10 plus récents',
		en: 'Last 10 documents',
	},
	subtitle_x_documents_found: {
		tag: 'document.files.subtitle_x_documents_found',
		fr: '{{count}} documents trouvés',
		en: '{{count}} files found',
		plurals: {
			zero: {
				fr: 'Aucun document trouvé',
				en: 'No file found',
			},
			one: {
				fr: '{{count}} fichier trouvé',
				en: '{{count}} file found',
			},
			other: {
				fr: '{{count}} fichiers trouvés',
				en: '{{count}} files found',
			},
		},
	},
	subtitle_all_my_document: {
		tag: 'document.files.subtitle_all_my_document',
		fr: 'Tous mes documents',
		en: 'All my documents',
	},
	x_files: {
		tag: 'document.files.x_files',
		fr: '{{count}} fichiers',
		en: '{{count}} files',
		plurals: {
			zero: {
				fr: 'Aucun fichier',
				en: 'No file',
			},
			one: {
				fr: '{{count}} fichier',
				en: '{{count}} file',
			},
			other: {
				fr: '{{count}} fichiers',
				en: '{{count}} files',
			},
		},
	},
	download_x_files: {
		tag: 'document.files.download_x_files',
		fr: 'Télécharger les {{count}} documents sélectionnés',
		en: 'Download {{count}} selected files',
		plurals: {
			zero: {
				fr: 'Aucun fichier',
				en: 'No file',
			},
			one: {
				fr: 'Télécharger le document sélectionné',
				en: 'Download the selected file',
			},
			other: {
				fr: 'Télécharger les {{count}} documents sélectionnés',
				en: 'Download {{count}} selected documents',
			},
		},
	},
	text_downloading: {
		tag: 'document.files.text_downloading',
		fr: 'Téléchargement en cours...',
		en: 'Downloading in progress...',
	},
	see_x_files: {
		tag: 'document.files.see_x_files',
		fr: 'Voir les {{count}} documents',
		en: 'View {{count}} documents',
		plurals: {
			zero: {
				fr: 'Aucun document',
				en: 'No document',
			},
			one: {
				fr: 'Voir le document',
				en: 'View the document',
			},
			other: {
				fr: 'Voir les {{count}} documents',
				en: 'View {{count}} documents',
			},
		},
	},
	search_autocomplete_header_document: {
		tag: 'document.files.search_autocomplete_header_document',
		fr: 'Document',
		en: 'Document',
	},
	search_autocomplete_header_fund: {
		tag: 'document.files.search_autocomplete_header_fund',
		fr: 'Fonds',
		en: 'Fund',
	},
	search_autocomplete_header_download: {
		tag: 'document.files.search_autocomplete_header_download',
		fr: 'Télécharger',
		en: 'Download',
	},
	search_autocomplete_placeholder: {
		tag: 'document.files.search_autocomplete_placeholder',
		fr: 'Recherche par nom de document...',
		en: 'Search by document name...',
	},
	btn_more_filters: {
		tag: 'document.files.btn_more_filters',
		fr: '+ de filtres',
		en: 'More filters',
	},
	btn_search_with_more_filters: {
		tag: 'document.files.btn_search_with_more_filters',
		fr: 'Recherche avancée',
		en: 'Advanced search',
	},
	btn_details: {
		tag: 'document.files.btn_details',
		fr: 'Détails',
		en: 'Details',
	},
	x_documents: {
		tag: 'document.files.x_documents',
		fr: '{{count}} documents',
		en: '{{count}} documents',
		plurals: {
			zero: {
				fr: 'Aucun document',
				en: 'No document',
			},
			one: {
				fr: '{{count}} document',
				en: '{{count}} document',
			},
			other: {
				fr: '{{count}} documents',
				en: '{{count}} documents',
			},
		},
	},
	x_docs: {
		tag: 'document.files.x_docs',
		fr: '{{count}} docs',
		en: '{{count}} docs',
		plurals: {
			zero: {
				fr: 'Aucun doc',
				en: 'No doc',
			},
			one: {
				fr: '{{count}} doc',
				en: '{{count}} doc',
			},
			other: {
				fr: '{{count}} docs',
				en: '{{count}} docs',
			},
		},
	},
	x_funds: {
		tag: 'document.files.x_funds',
		fr: '{{count}} fonds',
		en: '{{count}} funds',
		plurals: {
			zero: {
				fr: 'Aucun fonds',
				en: 'No fund',
			},
			one: {
				fr: '{{count}} fonds',
				en: '{{count}} fund',
			},
			other: {
				fr: '{{count}} fonds',
				en: '{{count}} funds',
			},
		},
	},
	mobile_list_documents_text_all_documents_displayed: {
		tag: 'document.files.mobile_list_documents_text_all_documents_displayed',
		fr: 'Tous les documents sont affichés',
		en: 'All documents displayed',
	},
	mobile_list_documents_text_view_x_more_documents: {
		tag: 'document.files.mobile_list_documents_text_view_x_more_documents',
		fr: 'Voir {{count}} documents supplémentaires...',
		en: 'View {{count}} more documents...',
		plurals: {
			zero: {
				fr: 'Tous les documents sont affichés',
				en: 'All documents displayed',
			},
			one: {
				fr: 'Voir {{count}} document supplémentaire...',
				en: 'View {{count}} more document...',
			},
			other: {
				fr: 'Voir {{count}} documents supplémentaires...',
				en: 'View {{count}} more documents...',
			},
		},
	},
	btn_go_to_fund_details: {
		tag: 'document.files.btn_go_to_fund_details',
		fr: 'Voir le détail du fonds',
		en: 'Go to fund details',
	},
	funds: {
		tag: 'document.files.funds',
		fr: 'Fonds',
		en: 'Funds',
	},
};

export default langDocumentFiles;
